import type { EvaluatedToilet } from "./types";

export type CandidateSortMode = "recommended" | "distance" | "freshness";

const confirmationTimestamp = (value?: string) => {
  if (!value) return null;
  const timestamp = Date.parse(value);
  return Number.isFinite(timestamp) ? timestamp : null;
};

export function sortCandidates(
  items: EvaluatedToilet[],
  mode: CandidateSortMode,
): EvaluatedToilet[] {
  const indexedItems = items.map((item, index) => ({ item, index }));

  if (mode === "recommended") {
    return indexedItems.map(({ item }) => item);
  }

  indexedItems.sort((left, right) => {
    if (mode === "distance") {
      return (
        left.item.distanceMeters - right.item.distanceMeters ||
        left.index - right.index
      );
    }

    const leftTimestamp = confirmationTimestamp(left.item.lastConfirmedAt);
    const rightTimestamp = confirmationTimestamp(right.item.lastConfirmedAt);
    if (leftTimestamp !== null && rightTimestamp !== null) {
      return rightTimestamp - leftTimestamp || left.index - right.index;
    }
    if (leftTimestamp !== null) return -1;
    if (rightTimestamp !== null) return 1;
    return left.index - right.index;
  });

  return indexedItems.map(({ item }) => item);
}
